import clsx from 'clsx';
import type { ReactNode } from 'react';

// Components
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';
import LinkBase from '@/components/base/LinkBase';

import type { LinkHrefType } from '@/lib/menu/main';

type MenuEntryPropsType = {
    name: string;
    children: ReactNode;
    link?: LinkHrefType;
    onClick?: () => void;
    isComingSoon?: boolean;
};

const MenuEntry = ({ name, children, link, onClick, isComingSoon }: MenuEntryPropsType) => {
    return (
        <Tooltip content={name} position="top-start" variant="menu" arrow={false} offset={[20, -5]}>
            {link ? (
                <div className="flex">
                    {isComingSoon ? (
                        <div className="group relative cursor-not-allowed leading-none">
                            {children}
                        </div>
                    ) : (
                        <LinkBase href={link} className="group relative leading-none">
                            {children}
                        </LinkBase>
                    )}
                </div>
            ) : (
                <button
                    className="group relative leading-none"
                    onClick={() => {
                        if (typeof onClick === 'function') {
                            onClick();
                        }
                    }}>
                    {children}
                </button>
            )}
        </Tooltip>
    );
};

type MenuIconPropsType = {
    icon: string;
    isOpen?: boolean;
    isActive?: boolean;
    isComingSoon?: boolean;
};

const MenuIcon = ({
    icon,
    isOpen = false,
    isActive = false,
    isComingSoon = false
}: MenuIconPropsType) => {
    return (
        <>
            <Icon
                icon={icon}
                className={clsx('align-middle text-xl', {
                    'text-icoGray-500 dark:text-icoDarkMode-wolf': !isActive,
                    'text-icoBlue': isActive,
                    'group-hover:hidden group-focus:hidden': !isOpen,
                    'opacity-30': isComingSoon,
                    hidden: isOpen
                })}
            />
            <Icon
                icon={`${icon}-on`}
                className={clsx('align-middle text-xl text-icoBlue', {
                    'hidden group-hover:inline-block group-focus:inline-block': !isOpen,
                    'opacity-30': isComingSoon
                })}
            />
        </>
    );
};

MenuEntry.Icon = MenuIcon;

export default MenuEntry;
